export const formatPhoneForWhatsApp = (phone: string, country?: string): string => {
  const originalPhone = String(phone || '').trim();
  const digitsOnly = originalPhone.replace(/\D/g, '');
  if (!digitsOnly) return '';

  if (originalPhone.startsWith('+')) return digitsOnly;
  if (digitsOnly.startsWith('00')) return digitsOnly.slice(2);
  if (digitsOnly.startsWith('60') || digitsOnly.startsWith('65')) return digitsOnly;

  const normalizedCountry = String(country || '').toUpperCase();
  if (normalizedCountry === 'SG') return `65${digitsOnly.replace(/^0+/, '')}`;

  if (digitsOnly.startsWith('0')) return `60${digitsOnly.slice(1)}`;
  return `60${digitsOnly}`;
};

export const getWhatsAppUrl = (phone: string, country?: string): string => {
  const formattedPhone = formatPhoneForWhatsApp(phone, country);
  return formattedPhone ? `https://wa.me/${formattedPhone}` : '';
};
